import React from 'react';
import _CopyRight from './_CopyRight.scss'

class CopyRight extends React.Component {

  render() {
    return (
      <div className='copyright-container'>
        <p className='footer-copyright-title'>SÀN THƯƠNG MẠI ĐIỆN TỬ TỈNH THỪA THIÊN HUẾ</p>
        <p className='footer-description'>Đơn vị chủ quản: SỞ CÔNG THƯƠNG TỈNH HUẾ</p>
        <p className='footer-description'>Địa chỉ: 02 Tôn Đức Thắng, Thành phố Huế, Tỉnh Thừa Thiên Huế</p>
        <p className='footer-description'>ĐT: 0234.3810096 / 0234 3823245 - Fax: 0234.3833147</p>
        <p className='footer-description'>Email: <a href="#">sct@thuathienhue.gov.vn</a></p>
      </div>
    );
  }
}
export default CopyRight;



// WEBPACK FOOTER //
// ./components/layouts/master/sub-footer/CopyRight.jsx